import { datadogRum } from "@datadog/browser-rum";

import appConfig from "./app";

export const initDatadogRum = () => {
  datadogRum.init({
    applicationId: appConfig.DATADOG_APPLICATION_ID,
    clientToken: appConfig.DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "hassibot",
    env: "prod",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 3,
    defaultPrivacyLevel: "mask-user-input",
    enableExperimentalFeatures: ["feature_flags"],
  });
  datadogRum.setGlobalContextProperty("buildHash", appConfig.BUILD_HASH);
};
